import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  pickerItem: {
    borderTop: `1px solid ${theme.white}`,
    paddingTop: 15,
    paddingBottom: 15
  }
}))
